import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CacheBustingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedReq = req;
    if (req.url.includes('/api')) {
      const noCacheUrl = req.url + (req.url.includes('?') ? '&' : '?') + 'v=' + new Date().getTime();
      const noCacheReq = req.clone({ url: noCacheUrl });
      modifiedReq = req.clone({url : noCacheUrl});
      return next.handle(noCacheReq);
    }
    return next.handle(req);
  }
}


// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { Router } from '@angular/router';
// import { catchError } from 'rxjs/operators';
// import { CommonService } from './shared/services/common.service';

// @Injectable()
// export class CacheBustingInterceptor implements HttpInterceptor {

//   constructor(private router: Router,  public common: CommonService) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//     let modifiedReq = req;

//     // Add cache busting
//     if (req.url.includes('/api')) {
//       const noCacheUrl = req.url + (req.url.includes('?') ? '&' : '?') + 'v=' + new Date().getTime();
//       modifiedReq = req.clone({ url: noCacheUrl });
//     }

//     // Apply error handling
//     return next.handle(modifiedReq).pipe(
//       catchError((error) => {
//         if (error.status === 423 || error.status === 417) {
//           //this.common.errorMsg("", "youNeedLogin", "top");
//           localStorage.setItem('token', '');
//           localStorage.setItem('isUserLoggedIn', 'false');
//           this.router.navigate(['auth/welcome']);
//         }

//         return throwError(() => error);
//       })
//     );
//   }
// }

